const COLOR = {
  YELLOW: {
    50: "#FFFDE7",
    100: "#FFF9C4",
    200: "#FFF59D",
    300: "#FFF176",
    400: "#FFEE58",
    500: "#FFEB3B",
    600: "#FDD835",
    700: "#FBC02D",
    800: "#F9A825",
    900: "#F57F17",
    A700: "#FFD600",
    A400: "#FFEA00",
    A200: "#FFFF00",
    A100: "#FFFF8D",
  },
  TEAL: {
    50: "#E0F2F1",
    100: "#B2DFDB",
    200: "#80CBC4",
    300: "#4DB6AC",
    400: "#26A69A",
    500: "#009688",
    600: "#00897B",
    700: "#00796B",
    800: "#00695C",
    900: "#004D40",
    A700: "#00BFA5",
    A400: "#1DE9B6",
    A200: "#64FFDA",
    A100: "#A7FFEB",
  },
  RED: {
    50: "#FFEBEE",
    100: "#FFCDD2",
    200: "#EF9A9A",
    300: "#E57373",
    400: "#EF5350",
    500: "#F44336",
    600: "#E53935",
    700: "#D32F2F",
    800: "#C62828",
    900: "#B71C1C",
    A700: "#D50000",
    A400: "#FF1744",
    A200: "#FF5252",
    A100: "#FF8A80",
  },
  PURPLE: {
    50: "#F3E5F5",
    100: "#E1BEE7",
    200: "#CE93D8",
    300: "#BA68C8",
    400: "#AB47BC",
    500: "#9C27B0",
    600: "#8E24AA",
    700: "#7B1FA2",
    800: "#6A1B9A",
    900: "#4A148C",
    A700: "#AA00FF",
    A400: "#D500F9",
    A200: "#E040FB",
    A100: "#EA80FC",
  },
  ORANGE: {
    50: "#FFF3E0",
    100: "#FFE0B2",
    200: "#FFCC80",
    300: "#FFB74D",
    400: "#FFA726",
    500: "#FF9800",
    600: "#FB8C00",
    700: "#F57C00",
    800: "#EF6C00",
    900: "#E65100",
    A700: "#FF6D00",
    A400: "#FF9100",
    A200: "#FFAB40",
    A100: "#FFD180",
  },
  LIGHT_GREEN: {
    50: "#F1F8E9",
    100: "#DCEDC8",
    200: "#C5E1A5",
    300: "#AED581",
    400: "#8BC34A",
    500: "#8BC34A",
    600: "#7CB342",
    700: "#689F38",
    800: "#558B2F",
    900: "#33691E",
    A700: "#64DD17",
    A400: "#76FF03",
    A200: "#B2FF59",
    A100: "#CCFF90",
  },
  LIGHT_BLUE: {
    50: "#E1F5FE",
    100: "#B3E5FC",
    200: "#81D4FA",
    300: "#4FC3F7",
    400: "#29B6F6",
    500: "#03A9F4",
    600: "#039BE5",
    700: "#0288D1",
    800: "#0277BD",
    900: "#01579B",
    A700: "#0091EA",
    A400: "#00B0FF",
    A200: "#40C4FF",
    A100: "#80D8FF",
  },
  INDIGO: {
    50: "#E8EAF6",
    100: "#C5CAE9",
    200: "#9FA8DA",
    300: "#7986CB",
    400: "#5C6BC0",
    500: "#3F51B5",
    600: "#3949AB",
    700: "#303F9F",
    800: "#283593",
    900: "#1A237E",
    A700: "#304FFE",
    A400: "#3D5AFE",
    A200: "#536DFE",
    A100: "#8C9EFF",
  },
  GREY: {
    50: "#FAFAFA",
    100: "#F5F5F5",
    200: "#EEEEEE",
    300: "#E0E0E0",
    400: "#BDBDBD",
    500: "#9E9E9E",
    600: "#757575",
    700: "#616161",
    800: "#424242",
    900: "#212121",
    A700: "#616161",
    A400: "#BDBDBD",
    A200: "#EEEEEE",
    A100: "#F5F5F5",
  },
  GREEN: {
    50: "#E8F5E9",
    100: "#C8E6C9",
    200: "#A5D6A7",
    300: "#81C784",
    400: "#66BB6A",
    500: "#4CAF50",
    600: "#43A047",
    700: "#388E3C",
    800: "#2E7D32",
    900: "#1B5E20",
    A700: "#00C853",
    A400: "#00E676",
    A200: "#69F0AE",
    A100: "#B9F6CA",
  },
  DEEP_PURPLE: {
    50: "#EDE7F6",
    100: "#D1C4E9",
    200: "#B39DDB",
    300: "#9575CD",
    400: "#7E57C2",
    500: "#673AB7",
    600: "#5E35B1",
    700: "#512DA8",
    800: "#4527A0",
    900: "#311B92",
    A700: "#6200EA",
    A400: "#651FFF",
    A200: "#7C4DFF",
    A100: "#B388FF",
  },
  DEEP_ORANGE: {
    50: "#FBE9E7",
    100: "#FFCCBC",
    200: "#FFAB91",
    300: "#FF8A65",
    400: "#FF7043",
    500: "#FF5722",
    600: "#F4511E",
    700: "#E64A19",
    800: "#D84315",
    900: "#BF360C",
    A700: "#DD2C00",
    A400: "#FF3D00",
    A200: "#FF6E40",
    A100: "#FF9E80",
  },
  CYAN: {
    50: "#E0F7FA",
    100: "#B2EBF2",
    200: "#80DEEA",
    300: "#4DD0E1",
    400: "#26C6DA",
    500: "#00BCD4",
    600: "#00ACC1",
    700: "#0097A7",
    800: "#00838F",
    900: "#006064",
    A700: "#00B8D4",
    A400: "#00E5FF",
    A200: "#18FFFF",
    A100: "#84FFFF",
  },
  BLUE_GREY: {
    50: "#ECEFF1",
    100: "#CFD8DC",
    200: "#B0BEC5",
    300: "#90A4AE",
    400: "#78909C",
    500: "#607D8B",
    600: "#546E7A",
    700: "#455A64",
    800: "#37474F",
    900: "#263238",
    A700: "#455A64",
    A400: "#78909C",
    A200: "#B0BEC5",
    A100: "#CFD8DC",
  },
  BLUE: {
    50: "#F0F5FF",
    100: "#D2E2FF",
    200: "#B3CDFF",
    300: "#83AEFF",
    400: "#448CFF",
    500: "#1D74FF",
    600: "#1663DF",
    700: "#124FB2",
    800: "#123C82",
    900: "#0B2550",
    A700: "#2962FF",
    A400: "#2979FF",
    A200: "#448AFF",
    A100: "#82B1FF",
  },
  AMBER: {
    50: "#FFF8E1",
    100: "#FFECB3",
    200: "#FFE082",
    300: "#FFD54F",
    400: "#FFCA28",
    500: "#FFC107",
    600: "#FFB300",
    700: "#FFA000",
    800: "#FF8F00",
    900: "#FF6F00",
    A700: "#FFAB00",
    A400: "#FFC400",
    A200: "#FFD740",
    A100: "#FFE57F",
  },
} as const;

const _components = {
  appBar: { defaultFill: COLOR.GREY[100] },
  stepper: { connector: COLOR.GREY[400] },
  breadcrumbs: { collapseFill: COLOR.GREY[100] },
  avatar: { fill: COLOR.GREY[400] },
  switch: {
    slideFill: "#000000",
    knowFillDisabled: COLOR.GREY[100],
    knobFillEnabled: COLOR.GREY[50],
  },
  alert: {
    success: {
      background: "#EDF7ED",
      color: "#1E4620",
    },
    info: {
      background: "#E5F6FD",
      color: "#014361",
    },
    warning: {
      background: "#FFF4E5",
      color: "#663C00",
    },
    error: {
      background: "#FDEDED",
      color: "#5F2120",
    },
  },
  chip: {
    defaultFocusFill: "#00000033",
    defaultHoverFill: "#0000001f",
    defaultCloseFill: "#000000",
    defaultEnabledBorder: COLOR.GREY[400],
  },
  backdrop: {
    fill: "#000000b3",
  },
  tooltip: { fill: "#616161e6" },
  snackbar: { fill: "#323232" },
  rating: { activeFill: "#FFB400", enabledBorder: "#0000003b" },
  input: {
    filled: { hoverFill: "#00000017", enabledFill: "#0000000f" },
    outlined: { hoverBorder: "#000000", enabledBorder: "#00000029" },
    standard: { hoverBorder: "#000000", enabledBorder: "#0000006b" },
  },
};

const elevation = {
  outlined: "#E0E0E0",
};

const divider = {
  divider: "#0000001f",
};

const common = {
  white_states: {
    outlinedBorder: "#ffffff80",
    focusVisible: "#ffffff4d",
    focus: "#ffffff1f",
    selected: "#ffffff14",
    hover: "#ffffff0a",
    main: "#ffffff",
  },
  black_states: {
    outlinedBorder: "#00000080",
    focusVisible: "#0000004d",
    focus: "#0000001f",
    selected: "#00000014",
    hover: "#0000000a",
    main: "#000000",
  },
};

const success = {
  contrast: "#FFFFFF",
  light: COLOR.GREEN[500],
  dark: COLOR.GREEN[900],
  main: COLOR.GREEN[800],
  _states: {
    outlinedBorder: "#2E7D3280",
    focusVisible: "#2E7D324D",
    selected: "#2E7D3214",
    hover: "#2E7D320A",
  },
};

const info = {
  contrast: "#FFFFFF",
  light: COLOR.LIGHT_BLUE[500],
  dark: COLOR.LIGHT_BLUE[900],
  main: COLOR.LIGHT_BLUE[700],
  _states: {
    outlinedBorder: "#0288d180",
    focusVisible: "#0288d14d",
    selected: "#0288d114",
    hover: "#0288d10a",
  },
};

const warning = {
  contrast: "#FFFFFF",
  light: COLOR.ORANGE[500],
  dark: COLOR.ORANGE[900],
  main: COLOR.ORANGE[800],
  _states: {
    outlinedBorder: "#ef6c0080",
    focusVisible: "#ef6c004d",
    selected: "#EF6C0014",
    hover: "#EF6C000A",
  },
};

const error = {
  contrast: "#FFFFFF",
  light: COLOR.RED[400],
  dark: COLOR.RED[800],
  main: COLOR.RED[700],
  _states: {
    outlinedBorder: "#D32F2F80",
    focusVisible: "#D32F2F4D",
    selected: "#D32F2F14",
    hover: "#D32F2F0A",
  },
};

const alert = {
  success: {
    background: "#edf7ed",
    color: "#1e4620",
  },
  info: {
    background: "#e5f6fd",
    color: "#014361",
  },
  warning: {
    background: "#fff4e5",
    color: "#663c00",
  },
  error: {
    background: "#fdeded",
    color: "#5f2120",
  },
};

const action = {
  disabledBackground: "#0000001F",
  disabled: "#00000061",
  focus: "#0000001F",
  selected: "#00000014",
  hover: "#0000000A",
  active: "#0000008F",
};

const secondary = {
  contrast: "#FFFFFF",
  light: COLOR.PURPLE[300],
  dark: COLOR.PURPLE[700],
  main: COLOR.PURPLE[500],
  _states: {
    outlinedBorder: "#9C27B080",
    focusVisible: "#9C27B04D",
    focus: "#9C27B01F",
    selected: "#9C27B014",
    hover: "#9C27B00A",
  },
};

const primary = {
  contrastText: "#FFFFFF",
  light: COLOR.BLUE[400],
  dark: COLOR.BLUE[600],
  main: COLOR.BLUE[500],
  _states: {
    outlinedBorder: "#1D74FF80",
    focusVisible: "#1D74FF4D",
    focus: "#1D74FF1F",
    selected: "#1D74FF14",
    hover: "#1D74FF1A",
    selected2: COLOR.BLUE[500],
  },
};

const text = {
  disabled: "#00000061",
  secondary: "#00000099",
  primary: "#000000DE",
  _states: {
    focusVisible: "#0000004D",
    focus: "#0000001F",
    selected: "#00000014",
    hover: "#0000000A",
  },
};

const _native = { "scrollbar-bg": COLOR.GREY[200] };

export const COLOR_CONSTANTS = {
  COLOR,
  _components,
  elevation,
  divider,
  common,
  success,
  info,
  warning,
  error,
  alert,
  action,
  secondary,
  primary,
  text,
  _native,
} as const;

// MarkerColor는 shared/constants/constants.tsx에서 정본 관리
export type { MarkerColor } from "../../constants";
export { MARKER_COLORS } from "../../constants";

// GeoLog 미디어 스크림 톤은 scrim.ts에서 정본 관리
export { GEOLOG_SCRIM_RGB } from "./scrim";
